
























import CShareButtons from '~/components/shared/configurable/social/CShareButtons.vue'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  components: { CShareButtons },
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    modalTitle: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.show
      },
      set(newVisibility) {
        this.$emit('visibility-changed', newVisibility)
      }
    }
  }
})
